'use strict';

var _ = require('lodash');

/**
 * Market Analysis - Service tab - Charts
 */
var ServiceClassTransformerFactory = function ServiceClassTransformerFactory($filter, DataTransformer, configurationService, effectiveValueService, mergeScenarioDataService, renormalizeEffectiveValueService, momentService, featureToggleService, bookingsTrendCorrectionTransformationService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getTimeOfDaySize() {
    return configurationService.getTimeOfDayBucketSize();
  }
  function getDaysInMonth(year, month) {
    var isLeap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    return [31, isLeap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];
  }
  function ServiceClassTransformer(targetType, priority) {
    DataTransformer.call(this);
    this.sourceType = 'service';
    this.targetType = targetType;
    this.priority = priority || 0;
  }

  // prepares a map of revenue day plan values for a given market for a given month
  function createTargetDataMap(data, marketDemands) {
    if (!marketDemands || marketDemands.length === 0) {
      return;
    }
    var dayMarketRecords = {};
    _.forEach(marketDemands, function (entry) {
      var date = entry.departureDate;
      if (_.has(dayMarketRecords, [date, entry.origin, entry.destination, entry.posName, 'quantity'])) {
        dayMarketRecords[date][entry.origin][entry.destination][entry.posName].quantity++;
      } else {
        _.set(dayMarketRecords, [date, entry.origin, entry.destination, entry.posName, 'quantity'], 1);
      }
    });
    _.forEach(data.target, function (d) {
      var daysInMonth = getDaysInMonth(d.year, d.month);
      var dayTarget = d.targetValue / daysInMonth;
      for (var i = 1; i <= daysInMonth; i++) {
        var date = momentService.of(d.year + '-' + d.month + '-' + i, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.DATE_ISO);
        var dateString = rmMomentFormat(date, 'DATE_ISO');
        if (!_.has(dayMarketRecords, [dateString, d.marketOrigin, d.marketDestination, d.spos])) {
          continue;
        }
        var recordsQuantity = dayMarketRecords[dateString][d.marketOrigin][d.marketDestination][d.spos].quantity;
        dayMarketRecords[dateString][d.marketOrigin][d.marketDestination][d.spos][d.targetType] = dayTarget / recordsQuantity;
      }
    });
    return dayMarketRecords;
  }
  ServiceClassTransformer.prototype = Object.create(DataTransformer.prototype);
  ServiceClassTransformer.constructor = ServiceClassTransformer;
  ServiceClassTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ServiceClassTransformer.prototype.isCacheable = function () {
    return true;
  };
  ServiceClassTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + metrics.join('-');
  };
  ServiceClassTransformer.prototype.transform = function (data, metrics, metricDescriptor) {
    var dimension = metricDescriptor.dimension;
    var metricsKeys = [];
    var mlength = metrics.length;
    var isMappedMode = featureToggleService.isEnabled('MAPPED_MODE');
    for (var m = 0; m < mlength; m++) {
      metricsKeys[m] = 'm' + (m + 1);
    }
    var memoizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memoizedDOWOfMoment = _.memoize(getDOWOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedTimeOfDayOfMoment = _.memoize(getTimeOfDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedYearMonthDayOfMoment = _.memoize(getYearMonthDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var isDemandDistributionIncremental = configurationService.isDemandDistributionIncremental();
    function setEffectiveValues(result, entry) {
      if (!isDemandDistributionIncremental) {
        var effective = effectiveValueService.calculateAll(entry, 'service-demand-analysis');
        _.assign(result, effective);
      } else {
        result.effectiveRegularRemainingDemandFC = entry.regularRemainingDemandAdjustedFC === undefined ? entry.regularRemainingDemandFC : entry.regularRemainingDemandAdjustedFC;
        result.effectiveMappedRemainingDemandFC = entry.mappedRemainingDemandAdjustedFC === undefined ? entry.mappedRemainingDemandFC : entry.mappedRemainingDemandAdjustedFC;
        result.effectiveRegularAggregateShare = entry.regularEffShare;
        result.effectiveMappedAggregateShare = entry.mappedEffShare;
      }
    }
    var transformData = function transformData(serviceClasses) {
      var result = [];
      if (!serviceClasses || !serviceClasses.length) {
        return result;
      }
      for (var i = 0, length = serviceClasses.length; i < length; i++) {
        var entry = serviceClasses[i];
        var entryKey = entry.serviceId + entry.carrier + entry.market + entry.significantPOS + entry.classGroup + entry.className + entry.departureDate;
        var momentDepartureDate = memoizedMomentOfDepartureDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
        var curDOW = memoizedDOWOfMoment(momentDepartureDate);
        var curYMD = memoizedYearMonthDayOfMoment(momentDepartureDate);
        var newEntry = {
          entryKey: entryKey,
          market: entry.market,
          origin: entry.origin,
          posName: entry.significantPOS,
          departureDate: curYMD,
          departureDateMoment: momentDepartureDate,
          departureTimeMoment: momentDepartureDate,
          departureDateMomentTimeOfDay: memoizedTimeOfDayOfMoment(momentDepartureDate),
          departureDateMomentDDD: curDOW,
          className: entry.className,
          numberOfStops: entry.numberOfStops,
          significantPOS: entry.significantPOS,
          fare: entry.fare,
          destination: entry.destination,
          route: entry.route,
          classGroup: entry.classGroup,
          mappedLastYearCurrentBookings: entry.mappedLastYearCurrentBookings,
          mappedLastYearCurrentRevenue: entry.mappedLastYearCurrentRevenue,
          mappedLastYearFinalBookings: entry.mappedLastYearFinalBookings,
          mappedLastYearFinalRevenue: entry.mappedLastYearFinalRevenue,
          mappedReservationHoldingsTotal: entry.mappedReservationHoldingsTotal,
          mappedReservationHoldingsIdv: entry.mappedReservationHoldingsIdv,
          mappedReservationHoldingsGroup: entry.mappedReservationHoldingsGroup,
          mappedExpectedBookings: entry.mappedExpectedBookings,
          mappedRevenueTotal: entry.mappedRevenueTotal,
          mappedRevenueExpectedTotal: entry.mappedRevenueExpectedTotal,
          mappedYield: entry.mappedYield,
          mappedExpectedYield: entry.mappedExpectedYield,
          mappedLastYearYield: entry.mappedLastYearYield,
          mappedLastYearFinalYield: entry.mappedLastYearFinalYield,
          regularRevenuePaxDistance: entry.regularRevenuePaxDistance,
          regularExpectedRevenuePaxDistance: entry.regularExpectedRevenuePaxDistance,
          regularLastYearCurrentRevenuePaxDistance: entry.regularLastYearCurrentRevenuePaxDistance,
          regularLastYearFinalRevenuePaxDistance: entry.regularLastYearFinalRevenuePaxDistance,
          mappedRevenuePaxDistance: entry.mappedRevenuePaxDistance,
          mappedExpectedRevenuePaxDistance: entry.mappedExpectedRevenuePaxDistance,
          mappedLastYearCurrentRevenuePaxDistance: entry.mappedLastYearCurrentRevenuePaxDistance,
          mappedLastYearFinalRevenuePaxDistance: entry.mappedLastYearFinalRevenuePaxDistance,
          mappedRemainingDemandFC: entry.mappedRemainingDemandFC,
          calculatedMappedRemainingDemandFC: entry.calculatedMappedRemainingDemandFC,
          baseMappedRemainingDemandFC: entry.effectiveMappedBaseRemainingDemandFC,
          userTypeMappedRemainingDemandFC: entry.userTypeMappedRemainingDemandFC,
          userValueMappedRemainingDemandFC: entry.userValueMappedRemainingDemandFC,
          effectiveMappedRemainingDemandFC: entry.effectiveMappedRemainingDemandFC,
          mappedRemainingDemandFCCV: entry.mappedRemainingDemandFCCV,
          mappedRemainingDemandMWTP: entry.mappedRemainingDemandMWTP,
          mappedRemainingDemandMWTPCV: entry.mappedRemainingDemandMWTPCV,
          mappedRemainingDemandPreBTC: entry.mappedRemainingDemandPreBTC,
          mappedSellupRate: entry.mappedSellupRate,
          mappedAggregateShare: entry.mappedAggregateShare,
          userMappedAggregateShare: entry.userMappedAggregateShare,
          effectiveMappedAggregateShare: entry.effectiveMappedAggregateShare,
          regularIsBookingTrendCorrectionRequired: entry.regularIsBookingTrendCorrectionRequired,
          regularBookingTrendCorrectionFactor: entry.regularBookingTrendCorrectionFactor,
          mappedIsBookingTrendCorrectionRequired: entry.mappedIsBookingTrendCorrectionRequired,
          mappedBookingTrendCorrectionFactor: entry.mappedBookingTrendCorrectionFactor,
          startRtpRegularRemainingDemandFC: _.isNil(entry.startRtpRegularRemainingDemandFC) ? entry.daysToDeparture : entry.startRtpRegularRemainingDemandFC,
          startRtpMappedRemainingDemandFC: _.isNil(entry.startRtpMappedRemainingDemandFC) ? entry.daysToDeparture : entry.startRtpMappedRemainingDemandFC
        };
        if (isMappedMode) {
          _.assign(newEntry, {
            regularReservationHoldingsTotal: entry.regularReservationHoldingsTotal,
            regularReservationHoldingsIdv: entry.regularReservationHoldingsIdv,
            regularReservationHoldingsGroup: entry.regularReservationHoldingsGroup,
            regularExpectedBookings: entry.regularExpectedBookings,
            regularLastYearCurrentBookings: entry.regularLastYearCurrentBookings,
            regularLastYearCurrentRevenue: entry.regularLastYearCurrentRevenue,
            regularLastYearFinalBookings: entry.regularLastYearFinalBookings,
            regularLastYearFinalRevenue: entry.regularLastYearFinalRevenue,
            regularRevenueTotal: entry.regularRevenueTotal,
            regularRevenueExpectedTotal: entry.regularRevenueExpectedTotal,
            regularYield: entry.regularYield,
            regularExpectedYield: entry.regularExpectedYield,
            regularLastYearYield: entry.regularLastYearYield,
            regularLastYearFinalYield: entry.regularLastYearFinalYield,
            regularRemainingDemandFC: entry.regularRemainingDemandFC,
            calculatedRegularRemainingDemandFC: entry.calculatedRegularRemainingDemandFC,
            baseRegularRemainingDemandFC: entry.effectiveRegularBaseRemainingDemandFC,
            userTypeRegularRemainingDemandFC: entry.userTypeRegularRemainingDemandFC,
            userValueRegularRemainingDemandFC: entry.userValueRegularRemainingDemandFC,
            effectiveRegularRemainingDemandFC: entry.effectiveRegularRemainingDemandFC,
            regularRemainingDemandFCCV: entry.regularRemainingDemandFCCV,
            regularRemainingDemandMWTP: entry.regularRemainingDemandMWTP,
            regularRemainingDemandMWTPCV: entry.regularRemainingDemandMWTPCV,
            regularRemainingDemandPreBTC: entry.regularRemainingDemandPreBTC,
            regularSellupRate: entry.regularSellupRate,
            regularAggregateShare: entry.regularAggregateShare,
            userRegularAggregateShare: entry.userRegularAggregateShare,
            effectiveRegularAggregateShare: entry.effectiveRegularAggregateShare
          });
        }
        effectiveValueService.setDefaultTypes(newEntry);
        setEffectiveValues(newEntry, entry);
        result.push(newEntry);
      }
      return result;
    };
    return _.chain(data.domain.serviceClassPOS).thru(function (serviceClassPOS) {
      // Initial Transformation
      return transformData(serviceClassPOS);
    }).thru(function (transformedData) {
      // Merge Scenario Data Stage
      var domain = data.thirdDomain || data.secondDomain;
      var scenarioData = transformData(domain && domain.serviceClassPOS || []);
      return mergeScenarioDataService.merge(transformedData, scenarioData);
    }).thru(function (unNormalizedData) {
      // Normalization Data Stage
      if (renormalizeEffectiveValueService.shouldApplyRenormalization(unNormalizedData)) {
        return renormalizeEffectiveValueService.renormalizeAll(unNormalizedData);
      }
      return unNormalizedData;
    }).thru(function (normalizedData) {
      // Bookings Trend Correction
      return bookingsTrendCorrectionTransformationService.applyBTCFactor(normalizedData);
    }).thru(function (btcAppliedData) {
      // Further processing
      for (var i = 0; i < btcAppliedData.length; i++) {
        var entry = btcAppliedData[i];
        if (!dimension || dimension === 'regular') {
          entry.resHoldTotalCurrent = entry.regularReservationHoldingsTotal;
          entry.resHoldTotalExpected = entry.regularExpectedBookings;
          entry.resHoldTotalCurrentReference = entry.regularLastYearCurrentBookings;
          entry.resHoldTotalFinalReference = entry.regularLastYearFinalBookings;
          entry.revenueCurrent = entry.regularRevenueTotal;
          entry.revenueExpected = entry.regularRevenueExpectedTotal;
          entry.revenueCurrentReference = entry.regularLastYearCurrentRevenue;
          entry.revenueFinalReference = entry.regularLastYearFinalRevenue;
          entry.unadjustedDemand = entry.regularRemainingDemandFC;
          entry.adjustedDemand = entry.effectiveRegularRemainingDemandFC;
          entry.mwtpDemand = entry.regularRemainingDemandMWTP;
          entry.yieldCurrent = entry.regularYield;
          entry.yieldExpected = entry.regularExpectedYield;
          entry.yieldCurrentReference = entry.regularLastYearYield;
          entry.yieldFinalReference = entry.regularLastYearFinalYield;
          entry.revenuePaxDistanceCurrent = entry.regularRevenuePaxDistance;
          entry.revenuePaxDistanceExpected = entry.regularExpectedRevenuePaxDistance;
          entry.revenuePaxDistanceCurrentReference = entry.regularLastYearCurrentRevenuePaxDistance;
          entry.revenuePaxDistanceFinalReference = entry.regularLastYearFinalRevenuePaxDistance;
        } else {
          entry.resHoldTotalCurrent = entry.mappedReservationHoldingsTotal;
          entry.resHoldTotalExpected = entry.mappedExpectedBookings;
          entry.resHoldTotalCurrentReference = entry.mappedLastYearCurrentBookings;
          entry.resHoldTotalFinalReference = entry.mappedLastYearFinalBookings;
          entry.revenueCurrent = entry.mappedRevenueTotal;
          entry.revenueExpected = entry.mappedRevenueExpectedTotal;
          entry.revenueCurrentReference = entry.mappedLastYearCurrentRevenue;
          entry.revenueFinalReference = entry.mappedLastYearFinalRevenue;
          entry.unadjustedDemand = entry.mappedRemainingDemandFC;
          entry.adjustedDemand = entry.effectiveMappedRemainingDemandFC;
          entry.mwtpDemand = entry.mappedRemainingDemandMWTP;
          entry.yieldCurrent = entry.mappedYield;
          entry.yieldExpected = entry.mappedExpectedYield;
          entry.yieldCurrentReference = entry.mappedLastYearYield;
          entry.yieldFinalReference = entry.mappedLastYearFinalYield;
          entry.revenuePaxDistanceCurrent = entry.mappedRevenuePaxDistance;
          entry.revenuePaxDistanceExpected = entry.mappedExpectedRevenuePaxDistance;
          entry.revenuePaxDistanceCurrentReference = entry.mappedLastYearCurrentRevenuePaxDistance;
          entry.revenuePaxDistanceFinalReference = entry.mappedLastYearFinalRevenuePaxDistance;
        }
        for (m = 0; m < mlength; m++) {
          var curMetricName = metrics[m];
          entry[metricsKeys[m]] = entry[curMetricName];
        }
      }
      var targetDataMap = createTargetDataMap(data.secondDomain, btcAppliedData);
      for (i = 0; i < btcAppliedData.length; i++) {
        var entryResult = btcAppliedData[i];
        entryResult.bookingsPlan = targetDataMap[entryResult.departureDate][entryResult.origin][entryResult.destination][entryResult.posName].Bookings;
        entryResult.revenuePlan = targetDataMap[entryResult.departureDate][entryResult.origin][entryResult.destination][entryResult.posName].Revenue;
        entryResult.yieldPlan = targetDataMap[entryResult.departureDate][entryResult.origin][entryResult.destination][entryResult.posName].Yield;
      }
      return btcAppliedData;
    }).value();
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  function getDOWOfMoment(moment) {
    return rmMomentFormat(moment, 'DAY_OF_WEEK');
  }

  /**
   *
   * @param moment
   * @param hour
   * @param minutes
   * @returns {MomentFactory}
   */
  function createMomentFromHour(moment, hour, minutes) {
    var dateString = rmMomentFormat(moment, 'DATE_ISO') + ' ' + hour + minutes;
    return momentService.of(dateString, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.DATE_HOURS_MINUTES);
  }
  function getTimeOfDayOfMoment(moment) {
    var cloned = moment.clone();
    var bucket = cloned.hours() - cloned.hours() % getTimeOfDaySize();
    var start = createMomentFromHour(cloned, bucket, ':00');
    var end = createMomentFromHour(cloned, Math.min(24, bucket + getTimeOfDaySize()) - 1, ':59');
    return [rmMomentFormat(start, momentService.TIME_USER_SETTINGS), rmMomentFormat(end, momentService.TIME_USER_SETTINGS)].join('-');
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE_ISO');
  }
  return ServiceClassTransformer;
};
ServiceClassTransformerFactory.$inject = ['$filter', 'DataTransformerFactory', 'ConfigurationService', 'CalculateEffectiveValueService', 'MergeScenarioDataService', 'RenormalizeEffectiveValueService', 'MomentService', 'FeatureToggleService', 'BookingsTrendCorrectionTransformationService'];
module.exports = ServiceClassTransformerFactory;